import React from "react";
import "./TextLong.css";

export default function ImageCaption(props) {
  const lines = props.imageCaption.split("\r\n\r\n");

  const processNoTag = (segment) => {
    const splitForClosingTag = segment.split(">");
    return splitForClosingTag.length > 1
      ? splitForClosingTag[1]
      : splitForClosingTag[0];
  };

  const tagToComponent = {
    h: "text-long-highlight",
    t: "text-title",
    q: "text-quote",
    s: "text-long-space",
    b: "text-long-bold",
    i: "text-long-italic",
    wh: "text-long-white",
    l: (content) => (
      <a
        className="text-long-link"
        rel="noreferrer"
        href={content.split("(")[1].split(")")[0]}
        target="_blank"
      >
        {content.split("(")[0]}
      </a>
    ),
  };

  const processTag = (segment) => {
    const [tag, content] = segment.split(">");

    if (tag in tagToComponent) {
      const TagComponent = tagToComponent[tag];
      if (typeof TagComponent === "function") {
        return TagComponent(content);
      }
      return <span className={TagComponent}>{content}</span>;
    }
    return content;
  };

  const renderParagraph = (paragraph) => {
    const splitForOpeningTag = paragraph.split("<");
    const paragraphClass = props.isMobile ? "caption-mobile" : "caption";

    return (
      <p className={paragraphClass}>
        {splitForOpeningTag.map((s, i) =>
          i % 2 === 0 ? processNoTag(s) : processTag(s)
        )}
      </p>
    );
  };

  const containerStyle = lines.length === 4
    ? {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        width: "80vw",
        margin: "0vh 10vw",
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: props.isMobile? "0vh 15vw 0vh 15vw":"0vh 25vw 0vh 20vw",
      };

  const itemStyle = {
    margin: props.isMobile ? "0vh 0vw 1vh 0vw" : "0vh 5vw 0vh 8vw", 
    padding: props.isMobile ? "0vh 0vw 1vh 0vw" : "0vh 0vw 0vh 0vw",
  };

  return (
    <div 
      style={{
        color: "white",
        backgroundColor: "black",
        textAlign: "center",
        overflow: "hidden",
        ...containerStyle,
      }}
    >
      {lines.map((p, i) => (
        <div key={i} style={itemStyle}>
          {renderParagraph(p)}
        </div>
      ))}
    </div>
  );
}
